import { inject } from '@angular/core';
import { type CanActivateFn, type RouterStateSnapshot } from '@angular/router';
import { StaffOidcAuthService } from './staff-oidc-auth.service';

/**
 * 스핀오프 세션(refresh 쿠키 + 메모리 access token) 기반 인증 가드.
 *
 * `StaffOidcAuthService.loadMe()`로 세션 유효성을 확인한다(토큰이 없으면 refresh 로 복원).
 *   - true → 세션 유효 → 라우트 진입 허용.
 *   - false → 세션 없음/만료 → `authorize-redirect`로 full-page navigate
 *     (`redirectToSignIn(state.url)`이 `return` 쿼리에 진입 시도한 URL을 실어 보낸다).
 *
 * 클라이언트 가드는 UX 용 — 실제 권한 강제는 서버 `StaffSessionGuard`가 담당한다.
 */
export const staffAuthGuard: CanActivateFn = async (
  _route,
  state: RouterStateSnapshot,
) => {
  const auth = inject(StaffOidcAuthService);

  const ok = await auth.loadMe();
  if (ok) return true;

  auth.redirectToSignIn(state.url);
  return false;
};
